import useSWR from "swr";
import { URL_API } from "../../../@richbeauty/services/endpoint";
import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";

const getAllLeads = async () => {
  const { data } = await jwtAxios.get(URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEADS, {
    params: {
      page: 1,
      take: 1000,
    },
  });
  return data;
};
const useGetAllCustomerLeads = () => {
  const fetcher = () => getAllLeads();
  return useSWR(
    {
      url: URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEADS,
      tags: ["#customerLeads"],
    },
    fetcher
  );
};

export default useGetAllCustomerLeads;
